/**
 * Custom Error class representing a failure to delete an entity.
 */
export class CannotDeleteError extends Error {
    /** Static error code to identify the error type. */
    static ERROR = 'CannotDeleteError'
    /** Optional identifier of the entity that couldn't be deleted. */
    id?: string

    /**
     * Creates a new CannotDeleteError.
     *
     * @param {string} [id] - Optional identifier of the entity that couldn't be deleted.
     * @param {string} [type] - Optional type or category of the entity.
     * @param {string} [message] - Optional custom error message.
     */
    constructor(id?: string, type?: string, message?: string) {
        super(message)
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain

        this.name = CannotDeleteError.ERROR
        this.id = id
        this.stack = new Error().stack
        if (id && type) {
            this.message = `${type} with id: ${id} cannot be deleted`
        }
    }
}
